import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  MenuItem,
  Select,
  Button,
  CircularProgress,
  Paper,
  TextField,
  Autocomplete ,
} from "@mui/material";
import SettingsIcon from "@mui/icons-material/Settings";
import { confirmarSistema } from "../Components/PopupSistema/PopupSistema";

import { useHistory } from "react-router-dom";
import { useRef } from "react";

/* 🔥 Firebase */
import { auth, db, storage } from "../Config/firebase";

import {
  collection,
  getDocs,
  addDoc,
  serverTimestamp,
  doc,
  getDoc,
  query,
  where,
  orderBy,
  updateDoc,
} from "firebase/firestore";


import {
  ref,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";

/* ✅ NAVBAR */
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { aplicarTenant, getUsuarioAtualComTenant, tenantWhere , consultaTenantAtual} from "../Utils/tenant";

export default function CadastroLaudos({ open, isMobile }) {
  const history = useHistory();

  function normalizarTexto(valor) {
    const texto = String(valor || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
      .toLowerCase();
    return texto === "relatorio de modulo de elasticidade"
      ? "relatorio modulo de elasticidade"
      : texto;
  }

  function obterRotuloObra(obra) {
    if (!obra) return "";
    return [obra.nome, obra.clienteNome].filter(Boolean).join(" — ");
  }

  const [obras, setObras] = useState([]);
  const [obraSelecionada, setObraSelecionada] = useState("");
  const [buscaObra, setBuscaObra] = useState("");
  const [arquivo, setArquivo] = useState(null);
  const [descricao, setDescricao] = useState("");
  const [numeroTraco, setNumeroTraco] = useState("");
  const [numeroRevisao, setNumeroRevisao] = useState("");
  const [loading, setLoading] = useState(false);
  const [tiposLaudo, setTiposLaudo] = useState([]);
  const [tipoSelecionado, setTipoSelecionado] = useState("");
  const [novoTipo, setNovoTipo] = useState("");
  const [mostrarNovoTipo, setMostrarNovoTipo] = useState(false);
  const inputNovoTipoRef = useRef(null);
  const [salvandoTipo, setSalvandoTipo] = useState(false);
  const [mensagem, setMensagem] = useState("");
  const [tipoMensagem, setTipoMensagem] = useState(""); // sucesso | erro
  const novoTipoContainerRef = useRef(null);
  const [ultimosLaudos, setUltimosLaudos] = useState([]);
  const [loadingPrevios, setLoadingPrevios] = useState(false);
  const [mostrarTodosPrevios, setMostrarTodosPrevios] = useState(false);
  const [mostrarConfiguracaoTipos, setMostrarConfiguracaoTipos] = useState(false);
  const [mostrarTodosTiposLaudo, setMostrarTodosTiposLaudo] = useState(false);
  const [laudoAtualizandoId, setLaudoAtualizandoId] = useState("");
  const [tipoAtualizando, setTipoAtualizando] = useState("");
  const [laudoEditandoId, setLaudoEditandoId] = useState("");
const [editNumeroTraco, setEditNumeroTraco] = useState("");
const [editNumeroRevisao, setEditNumeroRevisao] = useState("");
const [usuarioAtual, setUsuarioAtual] = useState(null);

  const tiposPadrao = [
  "Relatório de Rupturas",
  "Relatório de Dosagens",
  "Relatório de RAA",
  "Relatório Módulo de Elasticidade",
  "Relatório de ensaio de agregados"
];

const tiposCompletos = [
  ...tiposPadrao,
  ...tiposLaudo.filter((t) => !t.cancelado).map(t => t.nome)
];

// remover duplicados
const tiposUnicos = Array.from(
  tiposCompletos.reduce((mapa, tipo) => {
    const nome = String(tipo || "").trim();
    if (!nome) return mapa;

    const chave = normalizarTexto(nome);
    if (!mapa.has(chave)) {
      mapa.set(chave, nome);
    }

    return mapa;
  }, new Map()).values()
);

const tiposCadastradosUnicos = Array.from(
  tiposLaudo.reduce((mapa, tipo) => {
    const nome = String(tipo?.nome || "").trim();
    if (!nome) return mapa;

    const chave = normalizarTexto(nome);
    const atual = mapa.get(chave);
    const quantidade = (atual?.quantidade || 0) + 1;
    const cancelado = atual
      ? atual.cancelado && Boolean(tipo.cancelado)
      : Boolean(tipo.cancelado);

    mapa.set(chave, {
      ...tipo,
      nome,
      chave,
      quantidade,
      cancelado,
    });

    return mapa;
  }, new Map()).values()
).sort((a, b) =>
  String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR")
);

const tiposCadastradosVisiveis = mostrarTodosTiposLaudo
  ? tiposCadastradosUnicos
  : tiposCadastradosUnicos.filter((tipo) => !tipo.cancelado);

const totalTiposCancelados = tiposCadastradosUnicos.filter((tipo) => tipo.cancelado).length;

useEffect(() => {
  function handleClickFora(event) {
    if (
      mostrarNovoTipo &&
      novoTipoContainerRef.current &&
      !novoTipoContainerRef.current.contains(event.target)
    ) {
      setMostrarNovoTipo(false);
      setNovoTipo("");
    }
  }

  document.addEventListener("mousedown", handleClickFora);

  return () => {
    document.removeEventListener("mousedown", handleClickFora);
  };
}, [mostrarNovoTipo]);

useEffect(() => {
  if (tipoSelecionado && !tiposUnicos.some((tipo) => normalizarTexto(tipo) === normalizarTexto(tipoSelecionado))) {
    setTipoSelecionado("");
  }
}, [tipoSelecionado, tiposUnicos]);

  /* =========================
     CARREGAR OBRAS
  ========================= */
  useEffect(() => {
  async function carregarObras() {
    try {
      const user = auth.currentUser;
      if (!user) return;

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        alert("Usuário não encontrado");
        return;
      }

      const userData = await getUsuarioAtualComTenant();
      setUsuarioAtual(userData);

      // 🔑 CASO 1: ADMIN → vê todas as obras
      if (userData.tipo === "admin" || userData.admin === true) {
        const snap = await getDocs(query(collection(db, "obras"), ...tenantWhere(userData)));

        const lista = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setObras(lista);
        return;
      }

      // 🔑 CASO 2: CLIENTE → só as obras vinculadas
      let obrasIds = userData.obras || [];

      // limpeza defensiva
      obrasIds = obrasIds.filter(
        (id) => typeof id === "string" && id.trim() !== ""
      );

      if (obrasIds.length === 0) {
        alert("Usuário não possui obras vinculadas");
        return;
      }

      const obrasQuery = query(
        collection(db, "obras"),
        ...tenantWhere(userData),
        where("__name__", "in", obrasIds)
      );

      const snap = await getDocs(consultaTenantAtual(obrasQuery));

      const lista = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setObras(lista);

      if (lista.length === 1) {
        setObraSelecionada(lista[0].id);
        setBuscaObra(obterRotuloObra(lista[0]));
      }
    } catch (error) {
      console.error("Erro ao carregar obras:", error);
      alert("Erro ao carregar obras");
    }
  }

  carregarObras();
}, []);


useEffect(() => {
  async function carregarTipos() {
    if (!usuarioAtual) return;

    const snapTiposGerais = await getDocs(
      query(collection(db, "tiposLaudo"), ...tenantWhere(usuarioAtual))
    ).catch(() => null);
    const snapsPorObra = obras.length
      ? await Promise.all(
          obras.map((obra) =>
            getDocs(collection(db, "obras", obra.id, "tiposLaudo")).catch(() => null)
          )
        )
      : [];

    const mapa = new Map();

    if (snapTiposGerais) {
      snapTiposGerais.docs.forEach((documento) => {
        const dados = documento.data();
        const nome = String(dados.nome || "").trim();
        if (!nome) return;

        const chave = normalizarTexto(nome);
        mapa.set(chave, {
          id: documento.id,
          origem: "geral",
          ...dados,
          nome,
        });
      });
    }

    snapsPorObra.forEach((snap, obraIndex) => {
      if (!snap) return;

      snap.docs.forEach((documento) => {
        const dados = documento.data();
        const nome = String(dados.nome || "").trim();
        if (!nome) return;

        const chave = normalizarTexto(nome);
        if (!mapa.has(chave)) {
          mapa.set(chave, {
            id: documento.id,
            origem: "obra",
            obraId: obras[obraIndex]?.id || "",
            ...dados,
            nome,
          });
        }
      });
    });

    setTiposLaudo(
      Array.from(mapa.values()).sort((a, b) =>
        String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR")
      )
    );
  }

  carregarTipos();
}, [obras, usuarioAtual]);

useEffect(() => {
  async function carregarUltimosLaudos() {
    if (!usuarioAtual || !obraSelecionada || !tipoSelecionado) {
      setUltimosLaudos([]);
      setMostrarTodosPrevios(false);
      return;
    }

    setLoadingPrevios(true);

    try {
      const snap = await getDocs(
        query(
          collection(db, "laudos"),
          ...tenantWhere(usuarioAtual),
          where("obraId", "==", obraSelecionada),
          orderBy("criadoEm", "desc")
        )
      );

      const laudosFiltrados = snap.docs
        .map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }))
        .filter(
          (laudo) =>
            normalizarTexto(laudo.tipo) === normalizarTexto(tipoSelecionado)
        );

      setUltimosLaudos(laudosFiltrados);
      setMostrarTodosPrevios(false);
    } catch (error) {
      console.error("Erro ao carregar prévia dos laudos:", error);
      setUltimosLaudos([]);
    } finally {
      setLoadingPrevios(false);
    }
  }

  carregarUltimosLaudos();
}, [obraSelecionada, tipoSelecionado, usuarioAtual]);

async function salvarEdicaoLaudo(laudo) {
  setLaudoAtualizandoId(laudo.id);

  try {
    await updateDoc(doc(db, "laudos", laudo.id), {
      numeroTraco: editNumeroTraco,
      numeroRevisao: editNumeroRevisao,
    });

    setUltimosLaudos((prev) =>
      prev.map((item) =>
        item.id === laudo.id
          ? {
              ...item,
              numeroTraco: editNumeroTraco,
              numeroRevisao: editNumeroRevisao,
            }
          : item
      )
    );

    setLaudoEditandoId("");
    setEditNumeroTraco("");
    setEditNumeroRevisao("");
  } catch (error) {
    console.error("Erro ao editar laudo:", error);
    alert("Erro ao editar número do traço e revisão.");
  } finally {
    setLaudoAtualizandoId("");
  }
}

  async function imprimirLaudo(laudo) {
    const janela = window.open("", "_blank");

    if (!janela) {
      alert("O navegador bloqueou a abertura do PDF. Permita pop-ups para este site.");
      return;
    }

    janela.opener = null;

    try {
      const url = await getDownloadURL(ref(storage, laudo.storagePath));
      janela.location.replace(url);
    } catch (error) {
      janela.close();
      console.error("Erro ao imprimir laudo:", error);
      alert("Erro ao abrir o laudo para impressão.");
    }
  }

  async function alternarCancelamentoLaudo(laudo) {
    const cancelar = !laudo.cancelado;
    const mensagem = cancelar
      ? "Deseja cancelar este laudo? Ele não ficará visível para o cliente."
      : "Deseja reativar este laudo? Ele voltará a ficar visível para o cliente.";

    if (!(await confirmarSistema(mensagem))) return;

    setLaudoAtualizandoId(laudo.id);

    try {
      await updateDoc(doc(db, "laudos", laudo.id), {
        cancelado: cancelar,
      });

      setUltimosLaudos((prev) =>
        prev.map((item) =>
          item.id === laudo.id ? { ...item, cancelado: cancelar } : item
        )
      );
    } catch (error) {
      console.error("Erro ao atualizar cancelamento do laudo:", error);
      alert("Erro ao atualizar o status do laudo.");
    } finally {
      setLaudoAtualizandoId("");
    }
  }

  async function alternarCancelamentoTipo(tipo) {
    const cancelar = !tipo.cancelado;
    const mensagemConfirmacao = cancelar
      ? `Deseja cancelar o tipo "${tipo.nome}"? Ele não aparecerá mais na lista de seleção.`
      : `Deseja reativar o tipo "${tipo.nome}"? Ele voltará a aparecer na lista de seleção.`;

    if (!(await confirmarSistema(mensagemConfirmacao))) return;

    const chave = normalizarTexto(tipo.nome);
    const registrosMesmoTipo = tiposLaudo.filter(
      (item) =>
        normalizarTexto(item.nome) === chave &&
        item.id &&
        !String(item.id).startsWith("novo-")
    );

    if (!registrosMesmoTipo.length) {
      alert("Não foi possível localizar o tipo cadastrado para atualizar.");
      return;
    }

    setTipoAtualizando(chave);

    try {
      await Promise.all(
        registrosMesmoTipo.map((item) => {
          const tipoDocRef = item.origem === "geral" || !item.obraId
            ? doc(db, "tiposLaudo", item.id)
            : doc(db, "obras", item.obraId, "tiposLaudo", item.id);

          return updateDoc(tipoDocRef, {
            cancelado: cancelar,
          });
        })
      );

      setTiposLaudo((listaAtual) =>
        listaAtual.map((item) =>
          normalizarTexto(item.nome) === chave ? { ...item, cancelado: cancelar } : item
        )
      );

      if (cancelar && normalizarTexto(tipoSelecionado) === chave) {
        setTipoSelecionado("");
      }
    } catch (error) {
      console.error("Erro ao atualizar tipo de laudo:", error);
      alert("Erro ao atualizar o tipo de laudo.");
    } finally {
      setTipoAtualizando("");
    }
  }

  /* =========================
     SALVAR LAUDO
  ========================= */
  const salvarLaudo = async () => {
    if (!obraSelecionada) {
      alert("Selecione uma obra");
      return;
    }

    if (!arquivo) {
      alert("Selecione um arquivo PDF");
      return;
    }
    if (!tipoSelecionado) {
  alert("Selecione o tipo de laudo");
  return;
}


    if (!descricao.trim()) {
      alert("Informe a descrição do laudo");
      return;
    }

    if (!auth.currentUser) {
      alert("Usuário não autenticado");
      return;
    }

    setLoading(true);

    try {
      /* 1️⃣ Upload no Storage */
      const usuario = await getUsuarioAtualComTenant();
      if (!usuario.tenantId) {
        alert("Usuario sem tenantId. Use um admin de cliente SaaS para cadastrar laudos.");
        return;
      }

      const storagePath = `tenants/${usuario.tenantId}/laudos/${obraSelecionada}/${arquivo.name}`;
      const storageRef = ref(storage, storagePath);
      await uploadBytes(storageRef, arquivo);

      /* 2️⃣ Registro no Firestore */
      await addDoc(collection(db, "laudos"), aplicarTenant({
          obraId: obraSelecionada,
          tipo: tipoSelecionado,
          descricao,
          numeroTraco,
          numeroRevisao,
          nomeArquivo: arquivo.name,
          storagePath,
          cancelado: false,
          criadoPor: auth.currentUser.uid,
          criadoPorEmail: auth.currentUser.email || "",
          criadoEm: serverTimestamp(),
        }, usuario));


      setMensagem("Laudo cadastrado com sucesso!");
      setTipoMensagem("sucesso");

      /* 3️⃣ Reset */
      setArquivo(null);
      setDescricao("");
      setNumeroTraco("");
      setNumeroRevisao("");
      setObraSelecionada("");
      setBuscaObra("");
    } catch (error) {
      console.error("Erro ao salvar laudo:", error);
      setMensagem("Erro ao cadastrar laudo");
      setTipoMensagem("erro");
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     RENDER
  ========================= */
  const obrasOrdenadas = [...obras].sort((a, b) =>
  a.nome.localeCompare(b.nome, "pt-BR", { sensitivity: "base" })
);

  return (
    <>
      <Navbar open={open} isMobile={isMobile} />

      <Box
  sx={{
    p: 4,
    mt: 0,
    display: "flex",
flexDirection: "column",   // 🔥 ADICIONE ISSO
alignItems: "center",      // 🔥 ADICIONE ISSO
    background: "#f4f6f8",
    minHeight: "100vh",
  }}
>
        <Box sx={{ mb: 1, textAlign: "center" }}>
  <Typography
  variant="h5"
  fontWeight={700}
  sx={{ color: "#001969" }} // 🔥 azul petróleo
>
  Cadastro de Laudos
</Typography>
  <Typography variant="body2" color="text.secondary">
    Verifique o tipo de laudo selecionado antes de salvar!
  </Typography>
</Box>

        <Paper
  elevation={4}
  sx={{
    p: 2.5,
    width: "100%",
    maxWidth: 600,
    borderRadius: 3,
  }}
>
          {/* OBRA */}
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Obra
          </Typography>

    
<Autocomplete
  options={obrasOrdenadas}
  getOptionLabel={obterRotuloObra}
  inputValue={buscaObra}
  onOpen={() => {
    setMensagem("");
    setTipoMensagem("");
  }}
  value={
    obrasOrdenadas.find((o) => o.id === obraSelecionada) || null
  }
  onInputChange={(event, newInputValue, reason) => {
    setBuscaObra(newInputValue);
    if (reason === "input" || reason === "clear") {
      setMensagem("");
      setTipoMensagem("");
    }
  }}
  onChange={(event, newValue) => {
    setObraSelecionada(newValue ? newValue.id : "");
    setBuscaObra(obterRotuloObra(newValue));
    setMensagem("");
    setTipoMensagem("");
  }}
  renderInput={(params) => (
    <TextField
    size="small"
  {...params}
  label="Selecionar obra"
  placeholder="Pesquisar obra ou cliente"
  fullWidth
  onFocus={() => {
    setMensagem("");
    setTipoMensagem("");
  }}
  sx={{
  "& .MuiOutlinedInput-root": {
    height: 40, // 🔥 força altura
    "& input": {
      padding: "8px 12px", // 🔥 reduz altura interna
    },
  },
}}
/>
  )}
  sx={{ mb: 1.5 }}
/>
              <Typography variant="subtitle1" sx={{ mb: 1 }}>
                  Tipo de Laudo
                </Typography>            

                <Box sx={{ display: "flex", gap: 1, mb: 1.5 }}>
  <Select
  fullWidth
  value={tipoSelecionado}
  onChange={(e) => {
  setTipoSelecionado(e.target.value);

  if (e.target.value !== "Relatório de Dosagens") {
    setNumeroTraco("");
    setNumeroRevisao("");
  }
}}
>
    <MenuItem value="" disabled>
      Selecione o tipo
    </MenuItem>

    {tiposUnicos.map((tipo) => (
  <MenuItem key={tipo} value={tipo}>
    {tipo}
  </MenuItem>
))}
  </Select>

  <Button
  variant="contained"
  sx={{
    minWidth: 40,
    fontSize: 18,
    fontWeight: 700,
    padding: 0, // 🔥 remove altura extra
  }}

    onClick={() => {
      setMostrarNovoTipo(true);

      // pequeno delay para garantir render antes do foco
      setTimeout(() => {
        inputNovoTipoRef.current?.focus();
      }, 100);
    }}
  >
    +
  </Button>
</Box>
{mostrarNovoTipo && (
  <Box
    ref={novoTipoContainerRef}   // 🔥 AQUI ESTÁ O ERRO
    sx={{ display: "flex", gap: 1.5, mb: 3 }}
  >
    <TextField
    size="small"
      label="Novo Tipo de Laudo"
      fullWidth
      value={novoTipo}
      inputRef={inputNovoTipoRef}
      onChange={(e) => setNovoTipo(e.target.value)}
    />

    <Button
  variant="outlined"
  disabled={salvandoTipo}
  sx={{
    minWidth: 100,
    backgroundColor: salvandoTipo ? "#ccc" : undefined,
    color: salvandoTipo ? "#666" : undefined,
  }}
  onClick={async () => {
    if (!obraSelecionada) {
      const confirmarTipoGeral = await confirmarSistema(
        "Você não selecionou nenhuma obra para o relatório. O tipo será criado como geral e será mostrado para todas as obras. Deseja continuar?"
      );

      if (!confirmarTipoGeral) return;
    }

    const nomeTipo = novoTipo.trim();

    if (!nomeTipo) {
      alert("Digite o nome do tipo de laudo");
      return;
    }

    const tipoExistente = tiposUnicos.find(
      (tipo) => normalizarTexto(tipo) === normalizarTexto(nomeTipo)
    );

    if (tipoExistente) {
      setTipoSelecionado(tipoExistente);
      setNovoTipo("");
      setMostrarNovoTipo(false);
      return;
    }

    const tipoCanceladoExistente = tiposCadastradosUnicos.find(
      (tipo) => normalizarTexto(tipo.nome) === normalizarTexto(nomeTipo) && tipo.cancelado
    );

    if (tipoCanceladoExistente) {
      if (await confirmarSistema("Este tipo está cancelado. Deseja reativar para usar novamente?")) {
        await alternarCancelamentoTipo(tipoCanceladoExistente);
        setTipoSelecionado(tipoCanceladoExistente.nome);
        setNovoTipo("");
        setMostrarNovoTipo(false);
      }
      return;
    }

    setSalvandoTipo(true);

    try {
      const usuario = await getUsuarioAtualComTenant();
      if (!usuario.tenantId) {
        alert("Usuario sem tenantId. Use um admin de cliente SaaS para criar tipos de laudo.");
        return;
      }

      const tipoRef = await addDoc(
        collection(db, "tiposLaudo"),
        aplicarTenant(
          { nome: nomeTipo, cancelado: false, criadoEm: serverTimestamp() },
          usuario
        )
      );

      setTipoSelecionado(nomeTipo);
      setNovoTipo("");
      setMostrarNovoTipo(false);

      setTiposLaudo((listaAtual) =>
        [
          ...listaAtual,
          {
            id: tipoRef.id,
            origem: "geral",
            nome: nomeTipo,
            cancelado: false,
          },
        ].sort((a, b) =>
          String(a.nome || "").localeCompare(String(b.nome || ""), "pt-BR")
        )
      );
    } catch (error) {
      alert("Você não tem permissão para criar tipo de laudo");
    } finally {
      setSalvandoTipo(false);
    }
  }}
>
  {salvandoTipo ? (
    <>
      <CircularProgress size={18} sx={{ mr: 1 }} />
      Salvando...
    </>
  ) : (
    "Salvar"
  )}
</Button>
  </Box>
)}

   <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 1, mb: 1.5 }}>
  {tipoSelecionado === "Relatório de Dosagens" && (
    <>
      <TextField
        size="small"
        label="Nº do Traço"
        value={numeroTraco}
        onChange={(e) => setNumeroTraco(e.target.value.replace(/\D/g, ""))}
        inputProps={{
          inputMode: "numeric",
          pattern: "[0-9]*",
          maxLength: 10,
        }}
        sx={{
  width: "100%",
  "& .MuiOutlinedInput-root": { height: 40 },
          "& input": {
            padding: "8px 10px",
            textAlign: "center",
          },
        }}
      />

      <TextField
        size="small"
        label="Nº Revisão"
        value={numeroRevisao}
        onChange={(e) => setNumeroRevisao(e.target.value.replace(/\D/g, ""))}
        inputProps={{
          inputMode: "numeric",
          pattern: "[0-9]*",
          maxLength: 5,
        }}
        sx={{
  width: "100%",
  "& .MuiOutlinedInput-root": { height: 40 },
          "& input": {
            padding: "8px 10px",
            textAlign: "center",
          },
        }}
      />
    </>
  )}

  <Button
    variant="outlined"
    component="label"
    sx={{
  height: 40,
  width: "100%",
  borderStyle: "dashed",
      fontWeight: 500,
      whiteSpace: "nowrap",
    }}
  >
    Selecionar PDF

    <input
      type="file"
      hidden
      accept="application/pdf"
      onChange={(e) => {
        const file = e.target.files[0];
        if (!file) return;

        setArquivo(file);
        setDescricao(file.name.replace(/\.pdf$/i, ""));
      }}
    />
  </Button>
</Box>

{arquivo && (
  <Typography variant="body2" sx={{ mb: 2 }}>
    Arquivo selecionado: <strong>{arquivo.name}</strong>
  </Typography>
)}

          {/* BOTÕES */}
          <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
            <Button
              variant="outlined"
              color="inherit"
              fullWidth
              onClick={() => history.goBack()}
              disabled={loading}
            >
              Voltar
            </Button>

            <Button
  variant="contained"
  sx={{
    fontWeight: 600,
    background: "linear-gradient(90deg, #1976d2, #42a5f5)",
    boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
  }}
              fullWidth
              onClick={salvarLaudo}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} /> : "Salvar Laudo"}
            </Button>
          </Box>

              {mensagem && (
              <Box
  sx={{
    mt: 3,
    p: 1.5,
    borderRadius: 2,
    textAlign: "center",
    fontWeight: 600,
    background:
      tipoMensagem === "sucesso" ? "#e8f5e9" : "#ffebee",
    color:
      tipoMensagem === "sucesso" ? "#2e7d32" : "#c62828",
  }}
>
  {mensagem}
</Box>
            )}

            {tiposCadastradosUnicos.length > 0 && (
              <Box sx={{ mt: 3, pt: 2, borderTop: "1px solid #e0e0e0" }}>
                <Button
                  variant="outlined"
                  startIcon={<SettingsIcon />}
                  onClick={() => setMostrarConfiguracaoTipos((prev) => !prev)}
                  fullWidth
                  sx={{ justifyContent: "center", mb: mostrarConfiguracaoTipos ? 2 : 0 }}
                >
                  {mostrarConfiguracaoTipos ? "Ocultar configuração de tipos" : "Configurar tipos de laudo"}
                </Button>

                {mostrarConfiguracaoTipos && (
                  <>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                    mb: 1,
                  }}
                >
                  <Typography variant="subtitle1" fontWeight={700}>
                    Tipos de laudo cadastrados
                  </Typography>

                  {totalTiposCancelados > 0 && (
                    <Button
                      size="small"
                      variant="text"
                      onClick={() => setMostrarTodosTiposLaudo((prev) => !prev)}
                    >
                      {mostrarTodosTiposLaudo ? "Mostrar só ativos" : "Mostrar todos"}
                    </Button>
                  )}
                </Box>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5 }}>
                  Somente tipos ativos aparecem na lista de seleção.
                </Typography>

                {tiposCadastradosVisiveis.length === 0 ? (
                  <Typography variant="body2" color="text.secondary">
                    Nenhum tipo ativo cadastrado.
                  </Typography>
                ) : (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                  {tiposCadastradosVisiveis.map((tipo) => {
                    const atualizando = tipoAtualizando === tipo.chave;

                    return (
                      <Box
                        key={tipo.chave}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          gap: 1,
                          p: 1,
                          border: "1px solid #e0e0e0",
                          borderRadius: 2,
                          backgroundColor: tipo.cancelado ? "#fff5f5" : "#fafafa",
                        }}
                      >
                        <Box sx={{ minWidth: 0 }}>
                          <Typography variant="body2" fontWeight={700} sx={{ wordBreak: "break-word" }}>
                            {tipo.nome}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{
                              color: tipo.cancelado ? "#c62828" : "#2e7d32",
                              fontWeight: 700,
                            }}
                          >
                            {tipo.cancelado ? "Cancelado" : "Ativo"}
                            {tipo.quantidade > 1 ? ` - ${tipo.quantidade} cadastros iguais` : ""}
                          </Typography>
                        </Box>

                        <Button data-confirmacao-cancelamento="propria"
                          size="small"
                          variant="outlined"
                          color={tipo.cancelado ? "success" : "error"}
                          onClick={() => alternarCancelamentoTipo(tipo)}
                          disabled={atualizando}
                          sx={{ flexShrink: 0 }}
                        >
                          {atualizando ? "Salvando..." : tipo.cancelado ? "Reativar" : "Cancelar"}
                        </Button>
                      </Box>
                    );
                  })}
                </Box>
                )}
                  </>
                )}
              </Box>
            )}

        </Paper>

        <Paper
          elevation={2}
          sx={{
            mt: 2,
            p: 2.5,
            width: "100%",
            maxWidth: 600,
            borderRadius: 3,
          }}
        >
          <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>
            Prévias dos últimos laudos
          </Typography>

          {!obraSelecionada || !tipoSelecionado ? (
            <Typography variant="body2" color="text.secondary">
              Selecione a obra e o tipo de laudo para visualizar os últimos 4 registros.
            </Typography>
          ) : loadingPrevios ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
              <CircularProgress size={24} />
            </Box>
          ) : ultimosLaudos.length === 0 ? (
            <Typography variant="body2" color="text.secondary">
              Nenhum laudo encontrado para esta obra e este tipo.
            </Typography>
          ) : (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.2 }}>
              {(mostrarTodosPrevios ? ultimosLaudos : ultimosLaudos.slice(0, 4)).map((laudo, index) => (
                <Box
                  key={laudo.id}
                  sx={{
                    p: 1.5,
                    borderRadius: 2,
                    border: "1px solid #e0e0e0",
                    backgroundColor: laudo.cancelado ? "#fff5f5" : "#fafafa",
                    opacity: laudo.cancelado ? 0.85 : 1,
                  }}
                >
                  <Typography variant="body2" fontWeight={700}>
                    {index + 1}. {laudo.descricao || laudo.nomeArquivo || "Laudo sem descrição"}
                  </Typography>
                  <Typography variant="caption" display="block" color="text.secondary">
                    Arquivo: {laudo.nomeArquivo || "-"}
                  </Typography>
                  {laudo.relatorioCaracterizacaoId && Array.isArray(laudo.materiaisResumo) &&
                    laudo.materiaisResumo.map((material, materialIndex) => (
                      <Typography
                        key={material.id || materialIndex}
                        variant="caption"
                        display="block"
                        color="text.secondary"
                      >
                        Material: {material.descricao || "-"} — Local Coleta: {material.fornecedor || "-"}
                      </Typography>
                    ))}
                  <Typography variant="caption" display="block" color="text.secondary">
                    Data: {laudo.criadoEm?.toDate ? laudo.criadoEm.toDate().toLocaleDateString("pt-BR") : "-"}
                  </Typography>


              {laudo.tipo === "Relatório de Dosagens" && (
  laudoEditandoId === laudo.id ? (
    <Box sx={{ display: "flex", gap: 1, mt: 1 }}>
      <TextField
        size="small"
        label="Nº do Traço"
        value={editNumeroTraco}
        onChange={(e) =>
          setEditNumeroTraco(e.target.value.replace(/\D/g, ""))
        }
        sx={{ width: 130 }}
      />

      <TextField
        size="small"
        label="Nº Revisão"
        value={editNumeroRevisao}
        onChange={(e) =>
          setEditNumeroRevisao(e.target.value.replace(/\D/g, ""))
        }
        sx={{ width: 120 }}
      />
    </Box>
  ) : (
    <>
      <Typography variant="caption" display="block" color="text.secondary">
        Traço: {laudo.numeroTraco || "-"}
      </Typography>

      <Typography variant="caption" display="block" color="text.secondary">
        Revisão: {laudo.numeroRevisao || "-"}
      </Typography>
    </>
  )
)}

                  <Typography
                    variant="caption"
                    display="block"
                    sx={{
                      mt: 0.5,
                      fontWeight: 700,
                      color: laudo.cancelado ? "#c62828" : "#2e7d32",
                    }}
                  >
                    Status: {laudo.cancelado ? "Cancelado" : "Ativo"}
                  </Typography>
                  <Box sx={{ display: "flex", gap: 1, mt: 1.2, flexWrap: "wrap" }}>
                    
{laudo.tipo === "Relatório de Dosagens" && (
  laudoEditandoId === laudo.id ? (
    <>
      <Button
        size="small"
        variant="contained"
        onClick={() => salvarEdicaoLaudo(laudo)}
        disabled={laudoAtualizandoId === laudo.id}
      >
        {laudoAtualizandoId === laudo.id ? "Salvando..." : "Salvar"}
      </Button>

      <Button
        size="small"
        variant="outlined"
        color="inherit"
        onClick={() => {
          setLaudoEditandoId("");
          setEditNumeroTraco("");
          setEditNumeroRevisao("");
        }}
      >
        Cancelar
      </Button>
    </>
  ) : (
    <Button
      size="small"
      variant="outlined"
      onClick={() => {
        setLaudoEditandoId(laudo.id);
        setEditNumeroTraco(laudo.numeroTraco || "");
        setEditNumeroRevisao(laudo.numeroRevisao || "");
      }}
    >
      Editar
    </Button>
  )
)}


                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => imprimirLaudo(laudo)}
                      disabled={!laudo.storagePath}
                    >
                      Imprimir
                    </Button>
                    <Button data-confirmacao-cancelamento="propria"
                      size="small"
                      variant="outlined"
                      color={laudo.cancelado ? "success" : "error"}
                      onClick={() => alternarCancelamentoLaudo(laudo)}
                      disabled={laudoAtualizandoId === laudo.id}
                    >
                      {laudoAtualizandoId === laudo.id
                        ? "Salvando..."
                        : laudo.cancelado
                          ? "Reativar"
                          : "Cancelar"}
                    </Button>
                    <HistoricoCadastro colecao="laudos" documentoId={laudo.id} registro={laudo} />
                  </Box>
                </Box>
              ))}
              {ultimosLaudos.length > 4 && (
                <Button
                  size="small"
                  variant="text"
                  onClick={() => setMostrarTodosPrevios((prev) => !prev)}
                  sx={{ alignSelf: "flex-start" }}
                >
                  {mostrarTodosPrevios ? "Mostrar menos" : "Mostrar todos"}
                </Button>
              )}
            </Box>
          )}
        </Paper>
      </Box>
    </>
  );
}
